// extracted by mini-css-extract-plugin
module.exports = {"blockWrapper":"styles_blockWrapper___NC8q","slide":"styles_slide__TG7gL"};